"use client";
import { useLockBodyScroll } from "@uidotdev/usehooks";

const Skeleton = () => {
  useLockBodyScroll();
  return (
    <>
      {/* Hero Section */}
      <section className="mb-20">
        <div className="relative h-[270px] bg-white bg-radial md:h-[500px] xl:h-[680px]">
          {/* Header */}
          <div className="relative z-20 mx-auto flex h-full w-full max-w-[1340px] flex-col px-8 lg:px-4">
            <header className="hidden items-center justify-between pt-10 md:flex">
              {/* Logo */}
              <div className="h-[70px] w-[200px] animate-pulse rounded-lg bg-gray-200"></div>
              {/* Navigation */}
              <nav className="hidden basis-1/2 md:block">
                <ul className="flex grow justify-between gap-4">
                  {[1, 2, 3, 4].map((i) => (
                    <li
                      key={i}
                      className="h-6 w-24 animate-pulse rounded bg-gray-200"
                    ></li>
                  ))}
                </ul>
              </nav>
              {/* User Profile */}
              <div className="h-10 w-44 animate-pulse rounded-lg bg-gray-200"></div>
            </header>

            {/* Hero Content */}
            <div className="flex-center-col absolute inset-0 -z-20 h-full gap-4 xl:gap-8">
              <div className="space-y-4 text-center">
                <div className="mx-auto h-8 w-64 animate-pulse rounded-lg bg-gray-200 sm:h-10 xl:h-12"></div>
                <div className="mx-auto h-6 w-96 animate-pulse rounded-lg bg-gray-200"></div>
              </div>

              {/* Feature List */}
              <ul className="flex flex-wrap items-center justify-center gap-6 px-3 md:flex-nowrap md:justify-between xl:gap-8">
                {[1, 2, 3].map((i) => (
                  <li key={i} className="flex items-center gap-2">
                    <div className="h-4 w-4 animate-pulse rounded-full bg-gray-200"></div>
                    <div className="h-4 w-24 animate-pulse rounded bg-gray-200"></div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="mx-auto size-full max-w-[700px] px-8 lg:max-w-[900px] lg:px-4 xl:max-w-[1000px]">
        {/* Service Navigation */}
        <section className="relative z-30 mt-[-106px] mb-14 lg:mt-[-116px] xl:mb-20">
          <nav className="shadow-main lg:flex-center w-full overflow-hidden rounded-xl bg-white px-3.5 py-2.5 text-xs lg:px-6 lg:py-4 lg:text-sm xl:text-base">
            <ul className="flex justify-between gap-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <li
                  key={i}
                  className="h-8 w-32 animate-pulse rounded-lg bg-gray-200"
                ></li>
              ))}
            </ul>
          </nav>
        </section>

        {/* Form Section */}
        <section className="mb-10 w-full sm:mb-20 md:mb-30">
          <div className="flex flex-col items-center gap-8 sm:flex-row sm:items-start">
            {/* Left Column */}
            <div className="flex-column basis-3/5">
              <div className="rounded-2xl bg-white p-6 shadow-lg sm:p-8">
                <div className="space-y-4">
                  <div className="h-6 w-48 animate-pulse rounded bg-gray-200"></div>
                  <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
                  <div className="h-40 w-full animate-pulse rounded-lg bg-gray-200"></div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="flex-column basis-2/5">
              <div className="space-y-4">
                <div className="h-6 w-48 animate-pulse rounded bg-gray-200"></div>
                <div className="h-32 w-full animate-pulse rounded bg-gray-200"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Skeleton;
